import { render, staticRenderFns } from "./calendarBody.vue?vue&type=template&id=898058e6&scoped=true&"
import script from "./calendarBody.vue?vue&type=script&lang=js&"
export * from "./calendarBody.vue?vue&type=script&lang=js&"
import style0 from "./calendarBody.vue?vue&type=style&index=0&id=898058e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898058e6",
  null
  
)

export default component.exports